import { computed } from 'mobx'
import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import { type User } from 'entities/Users/model/User'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { checkHasCustomPermissions } from 'entities/Permissions'
import { EnumUserRoles } from 'entities/Users/model/types'

export class RowUser extends RowBase<User> {
  constructor(origin: User, private _entities: IEntitiesStore) {
    super(origin)

    makeObservableRowBase(this, {
      fullName: computed,
      email: computed,
      role: computed,
      roleLabel: computed,
      twoFaEnabled: computed,
      memberTeamsCount: computed,
      avatarInfo: computed,
      inboxes: computed,
      hasCustomPermissions: computed,
      isPaygLocked: computed,
      isAway: computed,
    })
  }

  get fullName() {
    return this.origin.full_name
  }

  get email() {
    return this.origin.email
  }

  get role() {
    return this.origin.origin.role
  }

  get roleLabel() {
    return this.origin.origin.role_label
  }

  get twoFaEnabled() {
    return this.origin.origin.two_fa_enabled
  }

  get memberTeamsCount() {
    return this.origin.origin.member_teams_count
  }

  get createdAt() {
    return this.origin.createdAt
  }

  get hasCustomPermissions(): boolean {
    return checkHasCustomPermissions(
      this.origin.permissions,
      this.origin.role,
      this._entities.permissionsStore.permissions
    )
  }

  get avatarInfo() {
    return this.origin.avatarInfo
  }

  get inboxes() {
    return this._entities.inboxesStore.organizationInboxes.filter((inbox) =>
      inbox.memberIds.includes(this.origin.id)
    )
  }

  get isPaygLocked() {
    return (
      this._entities.subscriptionStore.isPAYGPlan &&
      this.role !== EnumUserRoles.VIEW_ONLY &&
      this.role !== EnumUserRoles.OWNER
    )
  }

  get isAway() {
    return this.origin.isAway
  }
}
